module.exports = __webpack_public_path__ + "static/media/itinerary-demo.74b05df4.png";